<template>
    <div class="filter-min-max">
        <div class="filter-label" @click="showOptions = !showOptions">
            {{ valueLabel }}
        </div>
        <div
            class="filter-options"
            v-if="showOptions"
            v-click-outside="clickedOutsideOptions"
        >
            <div class="fields">
                <div class="field">
                    <label :for="inputId">{{ resolvedOptions.label }}:</label>
                    <input
                        type="tel"
                        v-model="number"
                        v-mask="resolvedOptions.mask"
                        :name="name"
                        :id="inputId"
                    />
                </div>
            </div>
            <div class="filter-actions">
                <button
                    type="button"
                    class="cancelBtn btn btn-sm btn-default"
                    @click="cancel"
                >
                    {{ t('reportFilters-close') }}
                </button>
            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
.field {
    display: flex;
    label {
        width: auto;
        display: block;
        margin-right: 10px;
    }
}
input {
    border: none;
    border-bottom: 1px solid #ddd;
    box-shadow: none;
    font-size: 13px;
    flex-grow: 1;
    width: 100%;
    &:focus {
        outline: none;
        box-shadow: none;
        border: none;
        border-bottom: 1px solid #ddd;
    }
}
</style>
<script>
export default {
    name: "number",
    props: {
        options: {
            type: Object,
            default: () => ({}),
        },
        name: {
            type: String,
            default: "number",
        },
        currentValue: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            showOptions: false,
            clickedOutsideOptions: () => {},
            value: "",
            changedValue: false,
            number: null,
        };
    },
    mounted() {
        if (this.currentValue) {
            this.number = this.currentValue;
        }
        if (this.value.length > 0) {
            this.changed();
        }
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        cancel() {
            this.showOptions = false;
        },
        changed() {
            this.$emit("changed", this.value);
        },
        setValue() {
            this.value = parseFloat(
                this.number.replace(/[^0-9,]/gi, "").replace(",", "."),
            );
        },
    },
    computed: {
        resolvedOptions() {
            return {
                mask: "R$ ######,##",
                label: this.t("inputs-keyvalue-value"),
                suffix: "",
                ...(this.options || {}),
            };
        },
        inputId() {
            return `filter-${this.name}`;
        },
        suffix() {
            return this.resolvedOptions.suffix !== undefined
                ? " " + this.resolvedOptions.suffix
                : "";
        },
        valueLabel() {
            return this.number ? this.number + this.suffix : this.t('reportFilters-not_informed');
        },
    },
    watch: {
        showOptions() {
            if (this.showOptions) {
                window.setTimeout(() => {
                    this.clickedOutsideOptions = () => {
                        if (this.showOptions) {
                            this.cancel();
                        }
                    };
                }, 100);
            } else {
                this.setValue();
                this.clickedOutsideOptions = () => {};
            }
        },
        value() {
            this.changed();
        },
    },
};
</script>
